












import { computed, defineComponent } from '@vue/composition-api'
import { hasVariants, isBundle } from '@futureecom/futureecom-js/dist/helpers/catalog/product-helpers'
import OrderableProductBundle from '@/components/domains/carts/product/OrderableProductBundle.vue'
import OrderableProductConfigurable from '@/components/domains/carts/product/OrderableProductConfigurable.vue'
import type {
  OrderableItemComponentData,
  OrderableItemData
} from '@futureecom/futureecom-js/dist/services/cart-service'
import type { Product } from '@futureecom/futureecom-js/dist/services/catalog-service'
import type { PropType } from '@vue/composition-api'
import type { ValidationErrors } from '@/types/validator'

export default defineComponent({
  name: 'OrderableAddProductSectionOptions',

  components: { OrderableProductBundle, OrderableProductConfigurable },

  props: {
    value: {
      type: Object as PropType<OrderableItemData>,
      required: true
    },
    product: {
      type: Object as PropType<Product>,
      required: true
    },
    errors: {
      type: Object as PropType<ValidationErrors>,
      default: () => ({})
    }
  },

  setup(props, { emit }) {
    const orderableData = computed({
      get: (): OrderableItemData => props.value,
      set: (val) => emit('input', val)
    })

    const isProductBundle = computed(() => isBundle(props.product))
    const isProductConfigurable = computed(() => hasVariants(props.product))

    const onConfigurableUpdate = (val?: Product) => {
      orderableData.value = { ...orderableData.value, product_id: val?.id || '' }
    }

    const onBundleUpdate = (components: OrderableItemComponentData[]) => {
      orderableData.value = { ...orderableData.value, components }
    }

    return {
      isProductBundle,
      isProductConfigurable,
      onConfigurableUpdate,
      onBundleUpdate
    }
  }
})
